import React, { useMemo } from 'react';
// import './Home.css';
import { IonContent, IonPage } from '@ionic/react';
import SearchHeader from '../components/Global/SearchHeader/SearchHeader';
import FeaturedItem from '../components/Catalogue/FeaturedItem/FeaturedItem';
import FilteredCarousel from '../components/Catalogue/FilteredCarousel/Carousel';
import Activities from '../components/Catalogue/Activities/Activities';
import StoryCard from '../components/Catalogue/Story/StoryCard';
import Footer from '../components/Global/Footer/Footer';
import {
	PlaceList,
} from '../models/factories/PlaceFactory';
import { Story } from '../models/Story';
import { ITaxonomy } from '../models/interfaces/ITaxonomy';
import { useAppSelector } from '../state/hooks';
import { PrefsPayload } from '../state/prefsSlice';
import _ from 'lodash';
import { SectionTitle } from '../components/Global/styles';
import {
	filterPlacesByAccessibility,
	filterStoriesByAccessibility,
	sortPlacesByPreferences,
	sortStoriesByPreferences,
} from '../models/helpers/preferenceRanking';

type HomeProps = {
	places: PlaceList;
	recentStories: Story[];
	stories: Story[];
	activities: ITaxonomy[];
};
const Home: React.FC<HomeProps> = ({ places, stories, recentStories, activities }) => {
	const userPrefs = useAppSelector((state) => state.prefs, _.isEqual) as PrefsPayload;

	const prioritisedPlaces = useMemo<PlaceList>(() => {
		const visiblePlaces = filterPlacesByAccessibility([...places.places], userPrefs);
		return {
			...places,
			places: sortPlacesByPreferences(visiblePlaces, userPrefs),
		};
	}, [places, userPrefs]);

	const prioritisedFeaturedStories = useMemo(
		() =>
			sortStoriesByPreferences(
				filterStoriesByAccessibility([...stories], userPrefs),
				userPrefs,
			),
		[stories, userPrefs],
	);

	const prioritisedRecentStories = useMemo(
		() =>
			sortStoriesByPreferences(
				filterStoriesByAccessibility([...recentStories], userPrefs),
				userPrefs,
			),
		[recentStories, userPrefs],
	);

	return (
		<IonPage>
			<IonContent fullscreen>
				<SearchHeader showAvatar={true} />
				<main>
					<FeaturedItem stories={prioritisedFeaturedStories} />
					{/*<FilteredCarousel*/}
					{/*	places={filteredTest}*/}
					{/*	title={'Your Places'}*/}
					{/*/>*/}
					<FilteredCarousel places={prioritisedPlaces} title={'Places'} />
					<Activities activities={activities} />
					{/*<FilteredCarousel places={places} title={'Places'} />*/}

					<SectionTitle>&nbsp;&nbsp;Recent Stories</SectionTitle>
					{prioritisedRecentStories.map((story) => {
						return (
							<StoryCard
								key={story.id}
								story={story}
								showDescription={true}
							/>
						);
					})}

					{/*<StoryCard story={stories[0]} />*/}

					<FilteredCarousel
						places={prioritisedPlaces}
						title="Places for you"
					/>
				</main>
				<Footer />
			</IonContent>
		</IonPage>
	);
};

export default Home;
